import { render, staticRenderFns } from "./TagCreateOrSearch.vue?vue&type=template&id=148ce48e&"
import script from "./TagCreateOrSearch.vue?vue&type=script&lang=js&"
export * from "./TagCreateOrSearch.vue?vue&type=script&lang=js&"
import style0 from "./TagCreateOrSearch.vue?vue&type=style&index=0&id=148ce48e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports